import ClaimingV2Context from '../contexts/ClaimingV2Context';
import { useContext } from 'react';

const useClaimingV2 = () => useContext(ClaimingV2Context);

export default useClaimingV2;
